import { forwardRef } from "react";

import { Select } from "../../UI/Select";
import { HelpTooltip } from "../HelpTooltip";

const TOOLTIP_HELP_CONTENT = "If an answer is retained, the user's response for this matching round will be carried over to future rounds. Once the user registers for a future round, they will have the option to update their answer if desired.";
export const RetainAnswerSelect = forwardRef((props, ref) => {

  const retainAnswerOptions = [
    { value: false, label: "Disabled" },
    { value: true, label: "Enabled" },
  ];

  const getValue = () => {
    if (typeof props.value === "object" && props.value !== null) {
      return props.value;
    }
    if (props.value === true) {
      return { value: true, label: "Enabled" };
    } else if (props.value === false) {
      return { value: false, label: "Disabled" };
    }
    return null;
  };

  return <HelpTooltip text={TOOLTIP_HELP_CONTENT}><Select {...props} value={getValue()} ref={ref} options={ retainAnswerOptions} /></HelpTooltip>;
});
